export default __webpack_public_path__ + "static/media/liberum-8.ea8ca24b.png";